import React from 'react';
import { useAppContext } from 'Context/ReactAppContext';
import { isFeatureFlipped } from 'Utils/feature-flipping/featureFlippingUtils';
import { MemberSignIn } from './MemberSignIn';
import { useExtendedConnect } from './useExtendedConnect';
export const MemberSignInContainer = () => {
  const appContext = useAppContext();
  const { isFacebookConnectAvailable, isWechatConnectAvailable } = useExtendedConnect();
  return (
    <MemberSignIn
      hasFacebookConnect={isFacebookConnectAvailable}
      hasQuickLogin={isFeatureFlipped(appContext)('navigationBar.hasQuickLogin')}
      hasWechatConnect={isWechatConnectAvailable}
    />
  );
};
